import { createSlice } from "@reduxjs/toolkit";
import { OutletTypes } from "../../controller/enum/OutletTypes";

const initialState = {
  outlet: OutletTypes.GUI,
};

//-----------------------------------------------------------------------------------

const outletSlice = createSlice({
  name: "outlet",
  initialState,
  reducers: {
    setOutlet(state, action) {
      state.outlet = action.payload;
    },
  },
});

//-----------------------------------------------------------------------------------

export const getOutletType = (state) => {
  return state.outlet.outlet;
};

//-----------------------------------------------------------------------------------

export default outletSlice.reducer;
export const { setOutlet } = outletSlice.actions;
